import { createI18n } from 'vue-i18n';

import enUS from '@/locales/en-US'
import zhCN from '@/locales/zh-CN'

 
type LanguageKey = 'en-US' | 'zh-CN'

// 获取浏览器语言设置
const getBrowserLanguage = (): LanguageKey => {
  const lang = navigator.language
  return lang.startsWith('zh') ? 'zh-CN' : 'en-US'
}

// 从 localStorage 获取保存的语言设置
const getSavedLanguage = (): LanguageKey | null => {
  const savedLang = localStorage.getItem('locale')
  return savedLang === 'zh-CN' || savedLang === 'en-US' ? savedLang : null
}

const i18n = createI18n({
  locale: getSavedLanguage() || getBrowserLanguage(), // Default language
  legacy: false, // Enable Composition API support
  globalInjection: true, // Allow global `$t` usage
  messages:{
    "en-US": enUS,
    "zh-CN": zhCN,
  },
});

export default i18n;